import { useState } from 'react';

import { StyledMenuEntry } from './styles/Menu';

const MenuEntry = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isFunction = typeof children === 'function';

  return <StyledMenuEntry>{isFunction ? children(isOpen, setIsOpen) : children}</StyledMenuEntry>;
};

export default MenuEntry;
